import React from "react";
import { Link } from "react-router-dom";
import { useBookLink } from "@/lib/settings";

/**
 * Wraps either an <a> (external Skedda) or <Link> (internal /book) so every
 * "Book a Lane" CTA across the app respects the admin booking-provider setting.
 *
 * Usage: <BookLink data-testid="..." className="...">Book Lane</BookLink>
 */
const BookLink = React.forwardRef(({ children, className, onClick, ...rest }, ref) => {
  const cfg = useBookLink();
  if (cfg.external) {
    return (
      <a
        ref={ref}
        href={cfg.href}
        target={cfg.target}
        rel={cfg.rel}
        className={className}
        onClick={onClick}
        {...rest}
      >
        {children}
      </a>
    );
  }
  return (
    <Link ref={ref} to={cfg.to} className={className} onClick={onClick} {...rest}>
      {children}
    </Link>
  );
});

BookLink.displayName = "BookLink";
export default BookLink;
